import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thaiStatus',
})
export class ThaiStatusPipe implements PipeTransform{
  engineStatusSet = {}
  status2Thai = {
    approved:'อนุมัติแล้ว',
    pending:'รอตรวจสอบ',
    wait_learning:'รอเรียน',
    wait_rating:'รอให้คะแนน',
    completed:'เสร็จสมบูรณ์',
    wait_teaching:'รอสอน',
    taught:'สอนแล้ว',
    payment_received:'ได้รับเงินแล้ว',
    learned:'เรียนแล้ว',
    rated:'ให้คะแนนแล้ว',
    paid_to_teacher:'จ่ายเงินให้ผู้สอนแล้ว',
    cancel:'ยกเลิก',
    negotiating:'อยู่ระหว่างเจรจา',
    accepted:'ตอบรับแล้ว',
    draft:'ฉบับร่าง',
    publish:'เผยแพร่',
    trash:'ถังขยะ',
    disable:'ยกเลิก',
    enable:'รออนุมัติ',
    confirmed:'อนุมัติแล้ว',
    'detailed completed':'รายละเอียดครบถ้วน',
    closed:'รายการเสร็จสมบูรณ์',
    wait_to_sell:'ยังไม่ได้ขาย',
    sold_partly:'ขายแล้วบางชิ้นส่วน',
    sold_out:'ขายหมดแล้ว',
    wait_checking_prior_sale:"ตรวจสอบก่อนขาย",
    wait_to_check:"ตรวสอบเอกสารที่รับมา",
    wait_seller_edit:"รอผู้ขายแก้ไข",
    doc_completed:"เอกสารสมบูรณ์",
    wait_send_to_buyer:"รอส่งเอกสารให้ผู้ซื้อ",
    wait_yellow_card:"รอใบลงทะเบียน",
    unit:"ขายแบบปกติ",
    partly:"ขายแยกชิ้นได้",
    table:"ตาราง",
    detail:"รายละเอียด",
    deleted:"ลบแล้ว",
    takeover:'ยึดเข้าสต็อก',
    '':"ทั้งหมด"
  }

  status_payment2Thai = {
    waiting:'รอการชำระ',
    partly:'ชำระบางส่วน',
    completed:'ชำระครบแล้ว'
  }

  stockTransfer = {
    pending:'รออนุมัติ',
    approved:'รอโอน',
    partly:'โอนแล้วบางส่วน',
    completed:'โอนครบแล้ว',
    deleted:'ลบแล้ว'
  }

  detailType2Thai = {
    all:'ทั้งหมด',
    product:'สินค้า',
    shipping:'ค่าขนส่ง'
  }

  shippingType2Thai = {
    ek:'ขนส่งทางบก',
    sea:'ขนส่งทางเรือ',
  }

  searchDateType2Thai = {
    'all':'ไม่ระบุวันที่',
    'purchase_date':'วันที่ใบรับของเข้า',
    'sales_date':'วันที่ขายออก'
  }

  searchDateStyle2Thai = {
    'specific':'วันเดียว',
    'period':'ช่วงเวลา',
  }

  sumBy2Thai = {
    '':'รายละเอียด',
    daily:'รายวัน',
    monthly:'รายเดือน',
    yearly:'รายปี'
  }

  salesType2Thai = {
    'wholesale':'ขายส่ง',
    'retail':'ขายปลีก'
  }

  salesChannel2Thai = {
    'online':'ออนไลน์',
    'counter':'หน้าร้าน'
  }

  paymentPurpose = {
    settle_interest:'ชำระดอกเบี้ย',
    settle_principal:'ชำระเงินต้น',
    transfer_principal:'โอนเงินต้น',
    etc:'อื่นๆ',
  }

  consignmentOverdueStatus = {
    '':'สถานะดอกเบี้ยทั้งหมด',
    overdue:'ค้างชำระดอกเบี้ย',
    no_overdue:'ไม่ค้างชำระดอกเบี้ย',
  }

  po_overview_status_stock = {
    '':"ทั้งหมด",
    'pending':'รอรับเข้าสต็อก',
    'approved':'รับเข้าสต็อกแล้ว'
  }

  product = {
    '':'ทั้งหมด',
    pending:'รอรับเข้า',
    approved:'สต็อกคงเหลือ',
    stock_out:'ขายแล้ว',
    deleted:'ลบแล้ว',
    repairing:'ส่งซ่อม',
    return_supplier:'คืน supplier',
    lost:'หาย',
    takeover:'ยึดเข้าสต็อก',
  }

  pmtMethod2Thai = {
    cash:'เงินสด',
    transfer:'โอน',
    credit_card:'บัตรเครดิต'
  }

  consignType={
    "consign":"ฝากขาย",
    "pawn":"จำนำ"
  }

  customerType2={
    general:"ทั่วไป",
    merchant:"แม่ค้า"
  }


  transform(value: any,type:string):string {
    if(type=='request') {
      this.status2Thai.pending = "รอตอบรับ";
    }

    var obj = {}
    if(type=='payment') {
      obj = this.status_payment2Thai
    }else if(type=='detail_type'){
      obj = this.detailType2Thai
    }else if(type=='shipping_type'){
      obj = this.shippingType2Thai
    }else if(type=='searchDateType2Thai'){
      obj = this.searchDateType2Thai
    }else if(type=='searchDateStyle2Thai'){
      obj = this.searchDateStyle2Thai
    }else if(type=='salesType2Thai'){
      obj = this.salesType2Thai
    }else if(type=='salesChannel2Thai'){
      obj = this.salesChannel2Thai
    }else if(type=='product'){
      obj = this.product
    }else if(type=='sumBy'){
      obj = this.sumBy2Thai
    }else if(type=='consignType'){
      obj = this.consignType
    }else if(type=='stockTransfer'){
      obj = this.stockTransfer
    }else if(type=='pmtMethod'){
      obj = this.pmtMethod2Thai
    }else if(type=='po_overview_status_stock'){
      obj = this.po_overview_status_stock
    }else if(type=='customerType2'){
      obj = this.customerType2
    }else if(type=='paymentPurpose'){
      obj = this.paymentPurpose
    }else if(type=='consignmentOverdueStatus'){
      obj = this.consignmentOverdueStatus
    }else{
      obj = this.status2Thai
    }

    return obj[value];
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/thai_status.pipe.ts